import { render } from "./StaffTrainingMaterialTab.vue?vue&type=template&id=0e86a25f"
import script from "./StaffTrainingMaterialTab.vue?vue&type=script&lang=js"
export * from "./StaffTrainingMaterialTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__